export default "__VITE_ASSET__BW3$yB$___"